import script from "./SelectEnttity.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectEnttity.vue?vue&type=script&setup=true&lang=js"

import "./SelectEnttity.vue?vue&type=style&index=0&id=20bffe8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20bffe8a"]])

export default __exports__